// extracted by mini-css-extract-plugin
export default {"imageContent":"Co-z","modal":"Do-z"};